import { useQuery } from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";
import type { QuestionAnswerRowDto } from "@green0meter-back/doubleMateriality/dtos/QuestionAnswerRow.dto";

import { DOMAIN_DOUBLE_MATERIALITY } from "../domain";

import { doubleMaterialityQuestionAnswersApi } from "@api/services";
import { roleGuard } from "@api";


const ACTION_GET_QUESTION_ANSWERS = "GET_QUESTION_ANSWERS";

export type QuestionAnswerRow = QuestionAnswerRowDto;

const getQuestionAnswers = async (): Promise<QuestionAnswerRow[]> => {
  const res =
    await doubleMaterialityQuestionAnswersApi.doubleMaterialityQuestionAnswersControllerFindAll();

  return (res.data as QuestionAnswerRow[]) || [];
};

export const useGetQuestionAnswers = (
  user: UserProfileDto | null,
): {
  answers?: QuestionAnswerRow[];
  enabled: boolean;
  isPending: boolean;
  refetch: () => void;
} => {
  const enabled = roleGuard(user, [UserRole.Owner, UserRole.Manager]);
  const { data, isPending, refetch } = useQuery({
    queryKey: [DOMAIN_DOUBLE_MATERIALITY, ACTION_GET_QUESTION_ANSWERS],
    queryFn: getQuestionAnswers,
    enabled,
    staleTime: 2 * 60 * 1000,
  });

  return { answers: data, enabled, isPending, refetch };
};
